export class TopSalesBaseElement {

  id: string;
  totalSalesRevenue: number = 0;
  topSalesQuantity: number = 0;


  constructor(id: string, totalSalesRevenue: number=0, topSalesQuantity: number=0) {
    this.id = id;
    this.totalSalesRevenue = totalSalesRevenue;
    this.topSalesQuantity = topSalesQuantity;
  }
}
